import type { DiseaseStatModel, ReviewTypeStatsModel } from "../../types/stats.types";
import { mockAssociationsRows, mockPublishedRecords } from "./climateAssociationsMock";
import { resolveCountryCodes } from "./countryResolver";

const CLIMATE_VARIABLE_COLUMN_KEYS = ['variable'];

const rvfStats = (() => {
    const countryCodes = new Set<string>();
    // Case-insensitive de-duplication, displayed with a leading capital.
    const climateVariables = new Map<string, string>();

    for (const row of mockAssociationsRows) {
        const country = row.values.country;
        resolveCountryCodes(typeof country === 'string' ? country : null).forEach(code => countryCodes.add(code));

        for (const key of CLIMATE_VARIABLE_COLUMN_KEYS) {
            const value = row.values[key];
            if (typeof value !== 'string' || !value.trim()) continue;
            const name = value.trim();
            climateVariables.set(name.toLowerCase(), name.charAt(0).toUpperCase() + name.slice(1));
        }
    }

    return {
        studyCount: mockPublishedRecords.length,
        countryCount: countryCodes.size,
        climateVariables: [...climateVariables.values()],
    };
})();

export const mockDiseaseStats: DiseaseStatModel[] = [
    {
        id: 1,
        name: "Ebola Virus",
        icon: "gorilla.svg",
        transmission: "Direct contact with infected animals or humans",
        studyCount: 0,
        countryCount: 0,
        climateVariables: ["Temperature", "Humidity", "Rainfall"],
    },
    {
        id: 2,
        name: "Rift Valley Fever",
        icon: "mosquito.svg",
        transmission: "Mosquito (Aedes, Culex spp.)",
        ...rvfStats,
    },
    {
        id: 3,
        name: "Henipah Virus",
        icon: "bat.svg",
        transmission: "",
        studyCount: 0,
        countryCount: 0,
        climateVariables: ["Temperature", "Rainfall"],
    },
    {
        id: 4,
        name: "Dengue Fever",
        icon: "mosquito.svg",
        transmission: "Mosquito (Aedes aegypti)",
        studyCount: 0,
        countryCount: 0,
        climateVariables: ["Temperature", "Rainfall", "Humidity"],
    },
    {
        id: 5,
        name: "Leptospirosis",
        icon: "rat.svg",
        transmission: "Contaminated water or soil",
        studyCount: 0,
        countryCount: 0,
        climateVariables: ["Rainfall", "Temperature"],
    },
    {
        id: 6,
        name: "Crimean-Congo Hemorrhagic Fever",
        icon: "tick.svg",
        transmission: "Tick",
        studyCount: 0,
        countryCount: 0,
        climateVariables: ["Temperature", "Rainfall", "Humidity"],
    },
    {
        id: 7,
        name: "Lassa Mammarenavirus",
        icon: "rat.svg",
        transmission: "Tick",
        studyCount: 0,
        countryCount: 0,
        climateVariables: ["Temperature"],
    },
    {
        id: 8,
        name: "Marburg Virus",
        icon: "gorilla.svg",
        transmission: "Tick",
        studyCount: 0,
        countryCount: 0,
        climateVariables: ["Rainfall", "Humidity"],
    },
    {
        id: 9,
        name: "Zika Virus",
        icon: "mosquito.svg",
        transmission: "Tick",
        studyCount: 0,
        countryCount: 0,
        climateVariables: ["Rainfall"],
    },
];

export const mockReviewTypeStats: ReviewTypeStatsModel[] = [
    // Only Rift Valley Fever has published data so far.
    { value: '1',                                      label: 'Diseases',          category: 'disease'          },
    { value: String(rvfStats.studyCount),              label: 'Studies',           category: 'study'            },
    { value: String(rvfStats.countryCount),            label: 'Countries',         category: 'country'          },
    { value: String(rvfStats.climateVariables.length), label: 'Climate Variables', category: 'climate_variable' },
];
